import axios from "axios";
const sap = axios.create({
  baseURL: process.env.VITE_API_SAP,
});

// const api = axios.create({
//   baseURL: "http://172.21.3.192:3333"
// });

// const apiImagem = axios.create({
//   baseURL: "http://172.21.3.192:3333",
//   timeout: 60 * 10 * 1000,
// })
const api = axios.create({
  baseURL: process.env.VITE_API_RRIM,
  // baseURL: "http://localhost:3333",
});

const apiImagem = axios.create({
  baseURL: process.env.VITE_API_RRIM,
  // Imagem - Timeput a 4 minutos
  timeout: 60 * 10 * 1000,
});

api.interceptors.request.use((config) => {
  let token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("auth._token.local="))
    .split("%20")[1];

  if (!token) {
    // window.location.replace("http://185.209.179.253:7800")
    // window.location.replace("http://185.209.179.253:7800")
    return;
  }

  config.headers.Authorization = `Bearer ${token}`;

  return config;
});

export { api, apiImagem, sap };
